import { Fragment } from 'react';
import type { NextPage } from 'next';
import { fadeInAnimate, slideInDownAnimate } from 'utils/animation';
import NextLink from 'components/reuseable/links/NextLink';
// -------- custom component -------- //
import { Hero1 } from 'components/blocks/hero';
import { Footer1 } from 'components/blocks/footer';
import ContactFooterCombo from 'components/reuseable/ContactFooterCombo';
import { seopricing } from 'data/answer-the-public/seo-pricing';
const answerThePublic = seopricing;
import Video from 'components/blocks/video/Video';

import SEO from 'components/common/SEO';
import * as All from 'data/keywords';

const details = {
  pageName: 'SEOptimist pricing',
  categories: 'seo, web design',
  description: 'SEOptimist pricing for the <hi></hi>ghest quality conversion rate optimisation services',
  parentDirectories: ''
};

const croPage: NextPage = () => {
  return (
    <>
      {/* ========== SEO META values ========== */}
      <SEO
        title={`${All.SEOPricing[0].title}`}
        description={details.description}
        tag={details.categories}
        urlPT={``}
        urlENPT={``}
        url={`${All.SEOPricing[0].url}/${All.SEOPricing[0].title.toLowerCase().replace(/ /g, '-')}`}
        image={`img/${All.HomeList[0].title.toLowerCase().replace(/ /g, '-')}.jpg`}
        // updated=""
        // published=""
        // modified=""
      />

      {/* ========== heading section ========== */}
      <Fragment>
        <main className="content-wrapper bg-white">
          {/* ========== hero section ========== */}
          <div style={fadeInAnimate('900ms')}>
            <Video
              heading="Seo Pricing"
              title1="SEO"
              title2="AUDIT"
              title3=""
              movie="/1.mp4"
              placeholder="1-bg.jpg"
              button="website-test"
              fontsize1={150}
              fontsize2={150}
              body=""
              intro=" helps London companies greatly improve Google ranking with affordably priced SEO packages. If&nbsp;you&nbsp;want to accelerate
              your business online, we are the experts using proprietary technology and AI."
            />
          </div>{' '}
          <section className="wrapper bg-light">
            <div className="container py-5">
              <div className="row">
                <div className="col-md-6 mx-auto">
                  <h2>{All.SEOPricing[0].title}</h2> {/*  SEO pricing UK */}
                  <p>
                    {All.SEOPricing[0].title} is an important consideration for businesses looking to invest in search
                    engine optimization services. At SEOptimist, we understand the significance of transparent and
                    competitive pricing when it comes to delivering exceptional value to our clients. As a leading
                    technical SEO agency, we strive to make {All.SEOPricing[0].title} accessible and affordable for
                    businesses of all sizes.
                  </p>
                  <p>
                    The pricing structure for SEO services in the UK can vary based on several factors. The scope of
                    work required, the level of competition in your industry, and the specific goals you aim to achieve
                    through SEO all play a role in determining the cost. At SEOptimist, your{' '}
                    <NextLink title={All.HomeList[0].title} href={'/'} />, we take a personalized approach to SEO
                    pricing in the UK. Our team works closely with you to understand your business objectives, budget
                    constraints, and desired outcomes. This allows us to create a tailored SEO strategy that maximizes
                    your return on investment.
                  </p>
                  <p>
                    Our flexible pricing options ensure that you can choose a package that suits your needs and budget.
                    Whether you're a small business with limited resources or a larger enterprise with more extensive
                    requirements, we have SEO pricing options that fit your specific circumstances. We believe in
                    transparency, and our team will provide a detailed breakdown of the services included in each
                    package, allowing you to make an informed decision.
                  </p>
                  <p>
                    By investing in SEO with SEOptimist, you can expect not only competitive pricing but also exceptional
                    results. Our experienced team of SEO professionals will work diligently to improve your website's
                    visibility, drive organic traffic, and boost your online presence. We are committed to delivering
                    tangible outcomes and helping your business thrive in the competitive online landscape.
                  </p>
                </div>
              </div>
            </div>
          </section>
          <div id="website-test"></div>
          <Hero1
            bgcolor="bg-soft-primary mb-20 mt-20"
            title={``}
            lead={``}
            body={[
              <div key={100} className="text-center" id="report">
                <p className="text-center fs-34 mb-0 mx-auto">
                  <strong>
                    GET YOUR FREE <span className="text-fuchsia">TECHNICAL SEO REPORT</span>
                  </strong>
                </p>
                <p className="text-center fs-18 mx-auto">
                  Action the findings from the report or purchase {All.HomeList[8].title}
                </p>
              </div>
            ]}
          />
          <section className="wrapper bg-light">
            <div className="container py-5">
              <div className="row">
                <div className="col-md-6 mx-auto">
                  <h2>{All.SEOPricing[1].title}</h2> {/*  SEO costs UK */}
                  <p>
                    {All.SEOPricing[1].title} can be a significant consideration for businesses looking to enhance their
                    online presence. At SEOptimist, we understand the importance of offering affordable SEO packages that
                    provide optimal results within your budget. We believe in transparency when it comes to{' '}
                    {All.SEOPricing[1].title}, ensuring that you have a clear understanding of the investment required
                    for our services.
                  </p>
                  <p>
                    Our pricing structure is designed to be transparent, with no hidden fees or surprises. We provide
                    detailed breakdowns of the services included in each package, allowing you to make an informed
                    decision based on your specific needs and goals. By knowing exactly what you're paying for, you can
                    allocate your resources effectively and make the most of your SEO investment.
                  </p>
                  <p>
                    While upfront {All.SEOPricing[1].title} may vary depending on factors such as the scope of work and
                    the competitiveness of your industry, it's important to consider the long-term benefits and the
                    impact on your business's growth. Investing in SEO can yield significant returns over time. Improved
                    organic rankings, increased website visibility, and targeted traffic can lead to higher conversions
                    and revenue generation.
                  </p>
                  <p>
                    At SEOptimist, we understand that every business is unique, and we tailor our SEO packages to meet
                    your specific requirements and budget. We work closely with you to develop a comprehensive SEO
                    strategy that aligns with your goals and ensures that you get the most value for your investment.
                    Our experienced team of SEO professionals will implement proven techniques and best practices to
                    improve your website's performance and drive sustainable growth.
                  </p>
                  <p>
                    By investing in SEO with SEOptimist, you're not only investing in the present but also in the future
                    success of your business. Our goal is to help you achieve long-term results and maximize the return
                    on your SEO investment. We believe that SEO costs in the UK should be an investment rather than an
                    expense, as the benefits can extend far beyond the initial upfront costs.
                  </p>
                  <h2>{All.SEOPricing[3].title}</h2> {/*  how much does SEO costs UK */}
                  <p>
                    At SEOptimist, your{' '}
                    <NextLink
                      title={All.EcommerceSEO[1].title}
                      href={
                        '/' + All.EcommerceSEO[0].url + '/' + All.EcommerceSEO[0].title.toLowerCase().replace(/ /g, '-')
                      }
                    />
                    , we know {All.SEOPricing[2].title} and we strive to deliver exceptional value for your investment.
                    Our team of experienced professionals works diligently to optimize your website, propose you a
                    tailored{' '}
                    <NextLink
                      title={All.SEOAudit[1].title}
                      href={'/' + All.SEOAudit[0].url + '/' + All.SEOAudit[0].title.toLowerCase().replace(/ /g, '-')}
                    />{' '}
                    with the best{' '}
                    <NextLink
                      title={All.CRO[2].title}
                      href={'/' + All.CRO[2].url + '/' + All.CRO[0].title.toLowerCase().replace(/ /g, '-')}
                    />
                    , and drive sustainable growth. We provide regular reporting and transparent communication, keeping
                    you informed about the progress and impact of our SEO efforts. Ready to unlock the potential of SEO
                    within your budget? Choose SEOptimist for transparent {All.SEOPricing[1].title}. Contact us today to
                    discuss your business goals and find an SEO package that suits your needs. Together, we can elevate
                    your online presence and achieve lasting success in the competitive digital landscape.
                  </p>
                  <h2>{answerThePublic[10].title}?</h2> {/*  why use SEO */}
                  <p>
                    In today's digital age, having a strong online presence is crucial for businesses of all sizes and
                    industries. Search Engine Optimization (SEO) plays a vital role in improving your website's
                    visibility and driving organic traffic from search engines. At SEOptimist, a leading SEO agency in
                    the UK, we understand the importance of utilizing SEO to enhance your online presence and achieve
                    business success. Let's explore {answerThePublic[10].title}, an essential tool for your digital
                    marketing strategy.
                  </p>
                  <p>
                    Increased Website Visibility: With our transparent and competitive SEO pricing UK, SEOptimist ensures
                    that your website ranks higher in search engine results pages (SERPs). By optimizing your website's
                    content, structure, and technical aspects, we enable search engines to understand and index your
                    site effectively. This increased visibility enhances your chances of reaching potential customers
                    and standing out from the competition.
                  </p>
                  <p>
                    Targeted Organic Traffic: Our tailored SEO strategies focus on attracting targeted and relevant
                    organic traffic to your website. Through extensive keyword research and optimization techniques, we
                    ensure that your website appears in search results for keywords that matter most to your business.
                    By driving quality traffic to your website, we increase the likelihood of conversions, leads, and
                    sales.
                  </p>
                  <p>
                    Improved User Experience: SEO goes hand in hand with providing a positive user experience. At SEOptimist 
                    SEO, we analyze your website's performance, user interface, and navigation to optimize user
                    experience. By improving loading speed, enhancing site structure, and delivering valuable content,
                    we ensure that visitors have a seamless browsing experience. A user-friendly website encourages
                    engagement, reduces bounce rates, and increases the chances of conversions.
                  </p>
                  <p>
                    Long-Term Business Growth: Our experienced team at SEOptimist understands the importance of long-term
                    business growth. We implement SEO strategies that focus on sustainable results. By continuously
                    optimizing your website, creating high-quality content, and building authoritative backlinks, we
                    establish a strong online presence that attracts organic traffic over time. This consistent growth
                    leads to increased brand recognition, customer loyalty, and business success.
                  </p>
                  <p>
                    Cost-Effectiveness: SEOptimist offers affordable SEO packages that provide a high return on
                    investment. Unlike paid advertising that incurs ongoing expenses, SEO brings organic traffic without
                    additional costs. By optimizing your website and targeting relevant keywords, we drive targeted
                    traffic to your site, reducing your reliance on paid channels. Our cost-effective SEO services
                    ensure that you maximize your digital marketing budget and achieve long-term results.
                  </p>
                  <p>
                    Competitive Advantage: In a sea of competitors, SEO gives you a significant advantage. By ranking
                    higher in search results and offering a superior user experience, you differentiate your business
                    from others in your industry. At SEOptimist, we help you outperform your competitors by implementing
                    effective SEO strategies tailored to your unique business goals and target audience.
                  </p>
                  <p>
                    SEOptimist is dedicated to help you understand what SEO is, {answerThePublic[10].title}, and what
                    results you can expect from us. Utilizing SEO is crucial for enhancing your online presence and
                    achieving business success. With SEOptimist's expertise in technical SEO, web analytics, and Google
                    Ads, we provide a comprehensive approach to improve your website's visibility, drive targeted
                    traffic, and maximize your online potential. Whether you're a small business or a large enterprise,
                    incorporating SEO into your digital marketing strategy is essential for staying competitive,
                    attracting customers, and achieving your business goals.
                  </p>
                  <h2>{answerThePublic[5].title}</h2> {/*  how to price SEO */}
                  <p>
                    Pricing SEO services can vary depending on several factors, such as the scope of work, the
                    competitiveness of the industry, and the desired results. When determining{' '}
                    {answerThePublic[5].title}, it's important to consider the value that SEO brings to a business. SEO
                    is not just about ranking higher in search engine results; it's about driving targeted organic
                    traffic, increasing visibility, and ultimately generating conversions and revenue.
                  </p>
                  <p>
                    Typically, SEO pricing is based on the level of service required and the amount of time and effort
                    needed to achieve the desired goals. Some SEO agencies offer fixed packages with predefined
                    services, while others provide custom pricing based on a thorough analysis of the client's website
                    and business needs. A comprehensive SEO strategy may include keyword research, on-page optimization,
                    technical SEO audits, link building, content creation, and ongoing monitoring and reporting.
                  </p>
                  <p>
                    When pricing SEO services, it's crucial to consider the long-term benefits that SEO can bring to a
                    business. Investing in SEO can lead to sustainable growth, increased brand visibility, and a
                    competitive edge in the online market. By attracting targeted organic traffic and optimizing the
                    user experience, SEO has the potential to generate a high return on investment (ROI) and deliver
                    lasting results.
                  </p>
                  <h2>{answerThePublic[9].title}</h2> {/*  why is SEO important for small businesses */}
                  <p>
                    For small businesses, SEO is a powerful tool that can level the playing field and help them compete
                    with larger, more established brands. In today's digital landscape, where online searches play a
                    crucial role in consumer decision-making, having a strong online presence is essential for small
                    businesses to succeed.
                  </p>
                  <p>
                    SEO provides small businesses with an opportunity to increase their visibility and reach a wider
                    audience. By optimizing their website and content for relevant keywords and phrases, small
                    businesses can improve their organic rankings in search engine results. This increased visibility
                    allows them to attract more targeted traffic and potential customers who are actively searching for
                    their products or services.
                  </p>
                  <p>
                    Moreover, SEO allows small businesses to establish credibility and build trust with their target
                    audience. By consistently providing valuable and relevant content, optimizing their website for a
                    seamless user experience, and earning high-quality backlinks from reputable sources, small
                    businesses can position themselves as authorities in their industry. This helps to build trust among
                    consumers, which can result in increased brand loyalty and customer retention.
                  </p>
                  <p>
                    Furthermore, SEO offers a cost-effective marketing strategy for small businesses. Compared to
                    traditional advertising methods, SEO can provide long-term results without the need for significant
                    ongoing investment. By investing in SEO, small businesses can drive organic traffic to their
                    website, generate leads, and increase conversions, all while optimizing their marketing budget.
                  </p>
                  <p>
                    In summary, SEO is crucial for small businesses because it allows them to increase their online
                    visibility, attract targeted traffic, build credibility, and achieve sustainable growth. By
                    implementing effective SEO strategies, small businesses can compete in the digital landscape and
                    reach their target audience, ultimately driving success and achieving their business goals.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </main>
        <ContactFooterCombo location="london" />
      </Fragment>
    </>
  );
};

export default croPage;
